import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,{attrs:{"single-line":"","hide-details":"","placeholder":"e.g. 8-16 1,2,3,4,5","error":_vm.formatIsBad},on:{"change":function($event){return _vm.emitValue()}},model:{value:(_vm.modified),callback:function ($$v) {_vm.modified=$$v},expression:"modified"}})}
var staticRenderFns = []

export { render, staticRenderFns }